import React, { useRef, useState } from "react";
import NewsletterArea from "../../containers/global/newsletter";
import PageBanner from "../../containers/global/page-banner";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import LifeAtNeoData from "../../data/life-at-neo.json";
import LifeAtNeoContainer from "../../containers/career/life-at-neo";
import LanMainContainer from "../../containers/career/lan-main";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";

const LifeAtNeoPage = () => {
    const [showFormSubmit, setshowFormSubmit] = useState("show");
    const contRef = useRef(null);
    const handleScrollToHeader = () => {
        console.log("scrllheader", contRef);
        if (contRef.current) {
            console.log("scrllheader2");
            // Adjust scrolling to account for the height of the small div
            const headerPosition = contRef.current.offsetTop;
            const divHeight = 0; // Adjust this if your div's height changes
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Life at NeoGrowth | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header
                        onPressSkipButton={() => {
                            handleScrollToHeader();
                        }}
                    />
                    <PageBanner
                        title="Life at NeoGrowth"
                        excerpt=""
                        image="/images/banner/page/career.png"
                    />

                    <LanMainContainer classOption="" mainData={LifeAtNeoData} />

                    <LifeAtNeoContainer
                        contRef={contRef}
                        mainData={LifeAtNeoData[1].laneo}
                    />

                    <LifeAtNeoContainer
                        contRef={contRef}
                        mainData={LifeAtNeoData[2].neo_reco}
                    />

                    <LifeAtNeoContainer
                        contRef={contRef}
                        mainData={LifeAtNeoData[3].neo_celeb}
                    />

                    <LifeAtNeoContainer
                        contRef={contRef}
                        mainData={LifeAtNeoData[4].neo_give_back}
                    />

                    <LifeAtNeoContainer
                        contRef={contRef}
                        mainData={LifeAtNeoData[5].neo_car}
                    />

                    <LifeAtNeoContainer
                        contRef={contRef}
                        mainData={LifeAtNeoData[6].neo_learn}
                    />

                    <Footer />
                    <ScrollToTop />
                    <div
                        // className={`modal ${1 == 1 ? "show" : ""}`}
                        className={`modal ${showFormSubmit ? "show" : ""}`}
                        style={{
                            backdropFilter: "blur(2px)",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            opacity: "1 !important",
                        }}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg ">
                            <div
                                className="modal-content radius-box"
                                style={{
                                    boxShadow: "0px 5px 5px -1px rgb(22 22 22)",
                                }}
                            >
                                <div className="modal-header text-white ">
                                    <h5 className="modal-title">
                                        We are Hiring Freshers!
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close btn btn-primary"
                                        aria-label="Close"
                                        onClick={() =>
                                            setshowFormSubmit(!showFormSubmit)
                                        }
                                    ></button>
                                </div>
                                <div className="modal-body text-center">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/career/FresherCampusHiring.jpeg`}
                                        alt="FresherCampusHiring"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default LifeAtNeoPage;
